{
  "Accessibility Menu": "Toegankelijkheidsmenu",
  "Reset settings": "Instellingen resetten",
  "Close": "Sluiten",
  "Content Adjustments": "Inhoudsaanpassingen",
  "Adjust Font Size": "Lettergrootte aanpassen",
  "Highlight Title": "Titel markeren",
  "Highlight Links": "Links markeren",
  "Readable Font": "Leesbaar lettertype",
  "Color Adjustments": "Kleur aanpassingen",
  "Dark Contrast": "Donker contrast",
  "Light Contrast": "Licht contrast",
  "High Contrast": "Hoog contrast",
  "High Saturation": "Hoge verzadiging",
  "Low Saturation": "Lage verzadiging",
  "Monochrome": "Monochroom",
  "Contrast": "Contrast",
  "Invert Colors": "Kleuren omkeren",
  "Tools": "Gereedschappen",
  "Reading Guide": "Leesgids",
  "Stop Animations": "Animaties stoppen",
  "Big Cursor": "Grote cursor",
  "Increase Font Size": "Lettergrootte vergroten",
  "Decrease Font Size": "Lettergrootte verkleinen",
  "Letter Spacing": "Letterafstand",
  "Line Height": "Regelhoogte",
  "Font Weight": "Letterdikte",
  "Dyslexia Font": "Dyslexie lettertype",
  "Language": "Taal",
  "Open Accessibility Menu": "Toegankelijkheidsmenu openen",
  "Widget Settings": "Widget-instellingen",
  "Widget Position": "Widget-positie",
  "Top Left": "Linksboven",
  "Top Center": "Middenboven",
  "Top Right": "Rechtsboven",
  "Center Left": "Midden links",
  "Center Right": "Midden rechts",
  "Bottom Left": "Linksonder",
  "Bottom Center": "Middenonder",
  "Bottom Right": "Rechtsonder",
  "Screen Reader": "Schermlezer",
  "Voice Navigation": "Spraaknavigatie",
  "Custom Color": "Aangepaste kleur",
  "Change the site's colors": "Wijzig de kleuren van de site",
  "Backgrounds": "Achtergronden",
  "Headings": "Kopteksten",
  "Contents": "Inhoud",
  "Reset colors": "Kleuren resetten",
  "Image Desaturation": "Beelddesaturatie",
  "Search languages": "Talen zoeken",
  "No languages found": "Geen talen gevonden",
  "Accessibility Profiles": "Toegankelijkheidsprofielen",
  "Motor Impaired": "Motorische beperking",
  "Big cursor, voice navigation, and no animations.": "Grote cursor, spraaknavigatie en geen animaties.",
  "Blind": "Blind",
  "Screen reader helpers with higher contrast.": "Schermlezer-hulpmiddelen met hoger contrast.",
  "Color Blind": "Kleurenblind",
  "High contrast palette with desaturated media.": "Palet met hoog contrast en minder verzadigde media.",
  "Dyslexia": "Dyslexie",
  "Friendly font, extra spacing, stronger weight.": "Vriendelijke letter, extra ruimte en dikkere stijl.",
  "Low vision": "Slechtziend",
  "Dark contrast and 130% magnification.": "Donker contrast en 130% vergroting.",
  "Cognitive & Learning": "Cognitief en leren",
  "Highlights key sections and enables voice help.": "Markeert belangrijke secties en schakelt spraakondersteuning in.",
  "Seizure & Epileptic": "Aanvallen en epilepsie",
  "Stops animations and desaturates imagery.": "Stopt animaties en verlaagt verzadiging van beelden.",
  "ADHD": "ADHD",
  "Reading guide, highlighted links, calmer palette.": "Leesgids, gemarkeerde links en rustiger kleuren.",
  "Widget Size": "Widgetgrootte",
  "Default": "Standaard",
  "Medium": "Gemiddeld",
  "Small": "Klein",
  "Color Blindness": "Kleurenblindheid",
  "Protanopia": "Protanopie",
  "Deuteranopia": "Deuteranopie",
  "Tritanopia": "Tritanopie",
  "Achromatopsia": "Achromatopsie",
  "Simulates and assists users with color vision deficiencies.": "Simuleert en helpt gebruikers met kleurenblindheid."
}
